<div *ngIf="cardsRepeatedCount != null && goalCount != null" class="open-widget">
  <div class="header">
    <tabler-icon name="target-arrow"></tabler-icon>
    <span>Wochenziel</span>
  </div>
  <div class="content">
    <span class="open-cards-count">{{cardsRepeatedCount}}</span>
    <span class="total-cards-count">von {{goalCount}} Wiederholungen</span>
  </div>
  <app-progress-bar *ngIf="!showButtonToSmartRepetition" [progress]="(cardsRepeatedCount == 0 && goalCount == 0) ? 0 : (cardsRepeatedCount! / goalCount!) * 100" [color]="'success'"></app-progress-bar>

  <button *ngIf="showButtonToSmartRepetition" [routerLink]="'/smart-repetition'">
    <span>Smartes Wiederholen</span>
    <tabler-icon name="arrow-right"></tabler-icon>
  </button>
</div>